import { createExperiencePage } from "../shared/createExperiencePage";

const defaultContent = {
  meta: {
    title: "Snowmobile Safari in Swedish Lapland | Cold Experience",
    description:
      "Carve across frozen lakes and through silent pine forests on a guided snowmobile adventure starting from our home in Swedish Lapland.",
    keywords:
      "snowmobile safari lapland, snowmobile tour sweden, winter adventure lapland, cold experience",
    ogTitle: "Snowmobile Safari in Swedish Lapland | Cold Experience",
    ogDescription:
      "Join our local guides for a premium snowmobile tour with top-class gear, wilderness lunch and real Lapland storytelling.",
    ogImage: "/og/snowmobile-safari.jpg",
    siteUrl: "https://coldexperience.se",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      name: "Snowmobile Safari in Swedish Lapland",
      description:
        "Guided snowmobile adventures with Cold Experience Lapland including wilderness lunch, premium equipment and small groups.",
      image: "/og/snowmobile-safari.jpg",
      provider: {
        "@type": "Organization",
        name: "Cold Experience Lapland",
      },
      location: {
        "@type": "Place",
        name: "Råstrand, Swedish Lapland",
      },
      url: "https://coldexperience.se/en/snowmobile-safari",
    },
  },
  media: {
    videoSrc: "/optimized_videos/snoskoter-opt.mp4",
    poster: "/images/Nya_bilder/IMG_6698.webp",
    introVideo: "/nya_filmer/snoskoter2.mp4",
    introPoster: "/images/Nya_bilder/IMG_3493.webp",
    scale: 1.6,
  },
  hero: {
    title: "Snowmobile Safari in Lapland",
    description:
      "Feel the rush of driving your own snowmobile across untouched winter landscapes together with local guides who know every trail.",
    primaryButton: {
      label: "Book Snowmobile Safari",
      target: "book",
    },
    secondaryButton: {
      label: "Ask About Availability",
      target: "contact",
    },
  },
  intro: {
    heading: "Ride where only snowmobiles can go",
    paragraphs: [
      "We tailor every tour to the day's weather and your experience level so you can focus on enjoying the ride.",
      "Warm up by the fire while your guide prepares a wilderness lunch with local flavours before we head back onto the trails.",
    ],
  },
  features: [
    {
      icon: "Shield",
      title: "Certified guides",
      description:
        "Professionals with avalanche and first-aid training lead every departure.",
    },
    {
      icon: "Mountain",
      title: "Spectacular terrain",
      description:
        "Reach frozen lakes, hidden valleys and panoramic viewpoints.",
    },
    {
      icon: "Clock",
      title: "Flexible durations",
      description: "Choose half-day, full-day or multi-day expeditions.",
    },
    {
      icon: "Camera",
      title: "Photo ready",
      description:
        "Plenty of stops to capture the northern scenery and your ride.",
    },
  ],
  sectionsHeading: "What the safari includes",
  sections: [
    {
      id: "tourHighlights",
      title: "Highlights on the trail",
      icon: "CheckCircle",
      items: [
        "Safety briefing and fitting of premium Arctic gear",
        "Small groups with one guide per 6 guests",
        "Routes across frozen lakes and through pine forests",
        "Wilderness lunch cooked over open fire",
        "Chances to spot reindeer, moose and arctic birds",
        "Optional evening departures for northern lights",
      ],
    },
    {
      id: "safety",
      title: "Safety & comfort",
      icon: "Shield",
      items: [
        "Latest Lynx and Ski-Doo touring snowmobiles",
        "DOT approved helmets, suits, boots and gloves",
        "Two-way radios between guides and support team",
        "Emergency equipment carried on every tour",
        "Heated shelter available during weather breaks",
        "Tow service and support vehicle on call",
      ],
    },
  ],
  dayProgram: {
    title: "Sample day program",
    steps: [
      {
        icon: "Shield",
        title: "Briefing & gear up",
        description:
          "Meet your guide, review safety and change into thermal gear.",
      },
      {
        icon: "Mountain",
        title: "Morning ride",
        description:
          "Follow our private trails across lakes and into the forest.",
      },
      {
        icon: "Coffee",
        title: "Wilderness lunch",
        description:
          "Enjoy a hot meal cooked over the fire in our timber hut.",
      },
      {
        icon: "Camera",
        title: "Scenic return",
        description:
          "Capture the final views before cruising back to base.",
      },
    ],
  },
  closing: {
    title: "Ready to ride with us?",
    description:
      "Reserve your snowmobile safari and let us design a Lapland adventure that matches your pace and interests.",
    primaryButton: {
      label: "Book Your Safari",
      target: "book",
    },
    secondaryButton: {
      label: "Plan with our team",
      target: "contact",
    },
    showStarRating: true,
    ratingText: "Rated 5/5 by snowmobile guests",
  },
  settings: {
    showFooter: false,
  },
};

export default createExperiencePage({
  translationKey: "snowmobileSafari",
  defaultContent,
  routeKey: "snowmobile-safari",
});
